<!--=====================================
  Login - Register Content
  ======================================-->

<div class="ps-my-account">
  <div class="container">
    <form
      #loginForm="ngForm"
      (ngSubmit)="onSubmit(loginForm)"
      class="ps-form--account ps-tab-root needs-validation"
      novalidate
    >
      <ul class="ps-tab-list">
        <li class="active"><a>Recuperar mi Contraseña</a></li>

        <!-- <li class=""><a href="#register">Register</a></li> -->
      </ul>

      <div class="ps-tabs">
        <!--=====================================
                      Login Form
                      ======================================-->

        <div class="ps-tab active" id="sign-in">
          <div class="ps-form__content">
            <h5>Ingrese nueva Contraseña</h5>

            <div class="form-group">
              <input
                class="form-control"
                type="password"
                placeholder="Ingrese Contraseña"
                [(ngModel)]="pass"
                name="password"
                required
                data-toggle="tooltip"
                title="Ingrese su nueva contraseña, debe contenet minimo 4 caracteres, mayusculas, minusculas y numeros"
                #password
              />
            </div>

            <div class="form-group">
              <input
                class="form-control"
                type="password"
                placeholder="Confirmar Contraseña"
                [(ngModel)]="pass1"
                name="password1"          
                data-toggle="tooltip"
                title="Ingrese su nueva contraseña, debe contenet minimo 4 caracteres, mayusculas, minusculas y numeros"
                #password1
              />          
            </div>

            <div class="form-group submtit">
              <button class="ps-btn ps-btn--fullwidth">Enviar</button>
            </div>
          </div>

          <!-- <div class="ps-form__footer">

                <p>Connect with:</p>

                <ul class="ps-list--social">

                  <li><a class="facebook" href="#"><i class="fab fa-facebook-f"></i></a></li>
                  <li><a class="google" href="#"><i class="fab fa-google"></i></a></li>

                </ul>

              </div> -->
          <br />
        </div>
        <!-- End Login Form -->
      </div>
    </form>
  </div>
</div>
